import React from 'react';
import ipChat from '../img/ip_chat.jpeg';
import ipChannel from '../img/ip_channel.jpeg';
import itChat from '../img/it_chat.jpeg';
import hubChannel from '../img/hub_channel.jpeg';
import novator from '../img/novator.png';
import jobChannel from '../img/job_channel.jpeg';
import gervice from '../img/gervice.jpg';
import botLogoGe from '../img/botLogoGe.png';
import botLogoPl from '../img/botLogoPl.png';
import botLogoSp from '../img/botLogoSp.jpg';
import payoneer from '../img/payoneer.png';
import chatGlobal from '../img/chat_global.jpeg';
import channelGlobal from '../img/channel_global.jpeg';
import faqYellow from '../img/faq_yellow.jpg';
import faqWhite from '../img/faq_white.jpg';
import acquiring from '../img/acquiring.jpg';
import crypto from '../img/crypto.jpg';
import styles from '../styles/components/projects.module.css';
import globalStyles from '../styles/global.module.css';

const ProjectsSection = () => {
  // Используем реальные изображения из проекта
  const projects = [
    { id: 1, name: 'Business chat', link: 'https://t.me/+L3csJ_oxdkplYTEy', imgPath: ipChat },
    { id: 2, name: 'Business channel', link: 'https://t.me/ipgeorgia', imgPath: ipChannel },
    { id: 3, name: 'IT chat', link: 'https://t.me/+GyUhX22fS75kOGNi', imgPath: itChat },
    { id: 4, name: 'Turnkey relocation', link: 'https://ipgeorgia.ge/relocation', imgPath: hubChannel },
    { id: 5, name: 'Networking', link: 'https://t.me/tbilisinovator1', imgPath: novator },
    { id: 6, name: 'Job channel', link: 'https://t.me/cvjobge', imgPath: jobChannel },
    { id: 7, name: 'Gervice (Organization of a comfortable life)', link: 'https://gervice.ge', imgPath: gervice },
    { id: 8, name: 'Our telegram-bot in Georgia', link: 'https://t.me/ipgeorgiabot', imgPath: botLogoGe },
    { id: 9, name: 'Our telegram-bot in Poland', link: 'https://t.me/ippolandbot', imgPath: botLogoPl },
    { id: 10, name: 'Our telegram-bot in Spain', link: 'https://t.me/ipspainbot', imgPath: botLogoSp },
    { id: 11, name: 'Payoneer', link: 'https://manageripgeorgia.atlassian.net/wiki/spaces/FAQ/pages/35684353/Payoneer', imgPath: payoneer },
    { id: 12, name: 'Business Global chat', link: 'https://t.me/ipglobalchat', imgPath: chatGlobal },
    { id: 13, name: 'Business Global channel', link: 'https://t.me/ip_global', imgPath: channelGlobal },
    { id: 14, name: 'Subscribe to the FAQ', link: 'https://ipgeorgia.ge/en/faq-subscribe', imgPath: faqYellow },
    { id: 15, name: 'FAQ IP/Business Gerogia/Global', link: 'https://manageripgeorgia.atlassian.net/wiki/spaces/FAQ/overview?homepageId=14287054', imgPath: faqWhite },
    { id: 16, name: 'Acquiring', link: 'https://manageripgeorgia.atlassian.net/wiki/x/CAD5HQ', imgPath: acquiring },
    { id: 17, name: 'Cryptocurrency exchange', link: 'https://manageripgeorgia.atlassian.net/wiki/x/AQCpFg', imgPath: crypto },
  ];

  return (
    <div className={styles.projectsSection}>
      <h2 className={styles.projectsTitle}>Our projects and partners</h2>
      <div className={`${globalStyles.container} ${styles.projectsGrid}`}>
        {projects.map(project => (
          <div className={styles.projectItem} key={project.id}>
            <a 
              className={styles.projectLink} 
              href={project.link} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <div className={styles.imageWrapper}>
                <img 
                  src={project.imgPath} 
                  className={styles.projectImage} 
                  alt={project.name} 
                />
              </div>
              <div className={styles.projectName}>{project.name}</div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectsSection; 